export default __webpack_public_path__ + "static/media/expand-more-blue-icon.8b15c2a9.svg";